/**
 * SOLID Review
 * S — Strong. Sole job: lazily construct a real LiveKitClientAdapter.
 * O — N/A — nothing to extend; a single factory function.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Implements the single-method IServiceLiveKitAdapter port.
 * D — Strong. Depends on its own sibling LiveKitClientAdapter via a dynamic import (not a static one) so
 *     the livekit-client SDK chunk stays out of the main bundle until a LiveKit connection is actually
 *     requested — matches the lazy-load behavior AppRoot.tsx used to do inline before Part 6d.
 */
import type { IServiceLiveKitAdapter, IGatewayLiveKit } from '../../application/ports/IGatewayLiveKit';

export const liveKitClientAdapterFactory: IServiceLiveKitAdapter = {
  async create(): Promise<IGatewayLiveKit> {
    const { LiveKitClientAdapter } = await import('./LiveKitClientAdapter');
    return new LiveKitClientAdapter();
  },
};
